// extracted by mini-css-extract-plugin
export default {"break-text":"yrvgqeLYM7iV2Sp4h2IQ","item":"lYQicF05lBIWe6UK7Vc8","show-more":"__XCmdtK7oL3B1IoiR6u"};